// tslint:disable
/* MACLE TypeScript 31/07/2026 23:43:15 */
import { ArrayList } from 'maf-web';

export abstract class BaseVO {
  readonly jclass: string = "com.sollus.vo.BaseVO";
}


export abstract class BaseData extends BaseVO {
  readonly jclass: string = "com.sollus.vo.BaseData";
}


export class BaseDataDisplay extends BaseData {
  readonly jclass: string = "com.sollus.vo.BaseDataDisplay";
  display: string = "";
  value: string = "";
}


export enum ETipoVendaNFe {
  NONE = 0,
  PRESENCIAL = 1,
  INTERNET = 2,
  OUTROS = 3,
  NFC_DELIVERY = 4,
  PRESENCIAL_FORA_ESTABELECIMENTO = 5,
}

export namespace ETipoVendaNFe {
  export function toDisplay(arg: ETipoVendaNFe): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Presencial";
      case 2: return "Internet";
      case 3: return "Outros";
      case 4: return "NFCe Delivery";
      case 5: return "Presencial fora do estabelecimento";
      default: return "";
    }
  }

  export function enums(): ETipoVendaNFe[] {
    return [ETipoVendaNFe.NONE,ETipoVendaNFe.PRESENCIAL,ETipoVendaNFe.INTERNET,ETipoVendaNFe.OUTROS,ETipoVendaNFe.NFC_DELIVERY,ETipoVendaNFe.PRESENCIAL_FORA_ESTABELECIMENTO];
  }
}


export class DataEndereco extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataEndereco";
  bairro: string = "";
  cidade: string = "";
  codCEP: number = 0;
  numero: string = "";
  codPais: number = 0;
  codUF: string = "";
  endereco: string = "";
  complemento: string = "";
}


export class DataClienteMacleAPP extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataClienteMacleAPP";
  servidorConsulta: string = "";
  fantasia: string = "";
  endereco: DataEndereco = new DataEndereco();
  codClienteMacle: number = 0;
}


export enum EGenero {
  NONE = 0,
  MASCULINO = 1,
  FEMININO = 2,
  UNISEX = 3,
}

export namespace EGenero {
  export function toDisplay(arg: EGenero): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Masculino";
      case 2: return "Feminino";
      case 3: return "Unisex";
      default: return "";
    }
  }

  export function enums(): EGenero[] {
    return [EGenero.NONE,EGenero.MASCULINO,EGenero.FEMININO,EGenero.UNISEX];
  }
}


export class PKFuncionario extends BaseData {
  readonly jclass: string = "com.sollus.vo.PKFuncionario";
  codFuncionario: number = 0;
  codEmpresa: number = 0;

  constructor()
  constructor(codEmpresa: number, codFuncionario: number)
  constructor(codEmpresa?: number, codFuncionario?: number) {
    super();
    this.codEmpresa = codEmpresa || 0;
    this.codFuncionario = codFuncionario || 0;
  }

  public getPK(): PKFuncionario {
    return new PKFuncionario(this.codEmpresa, this.codFuncionario);
  }

  public equals(arg: PKFuncionario): boolean {
    return arg 
        && (arg.codFuncionario === this.codFuncionario)
        && (arg.codEmpresa === this.codEmpresa)
    ;
  }
}


export class PKLong extends BaseData {
  readonly jclass: string = "com.sollus.vo.PKLong";
  codigo: number = 0;

  constructor()
  constructor(codigo: number)
  constructor(codigo?: number) {
    super();
    this.codigo = codigo || 0;
  }

  public getPK(): PKLong {
    return new PKLong(this.codigo);
  }

  public equals(arg: PKLong): boolean {
    return arg 
        && (arg.codigo === this.codigo)
    ;
  }
}


export class DataLOG extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataLOG";
  entidade: number = 0;
  acao: number = 0;
  usuario: PKFuncionario = new PKFuncionario();
  PKLog: string = "";
  request: number = 0;
  codLOG: number = 0;
  hora: string = "";
  replicado: boolean = false;
  base: number = 0;
  data: string = "";

  public getPK(): PKLong {
    let result: PKLong =  new PKLong();
    result.codigo = this.codLOG;
    return result;
  }

  public equals(arg: PKLong): boolean {
    return arg 
        && (arg.codigo === this.codLOG)
    ;
  }
}


export enum EUF {
  NONE = 0,
  AC = 1,
  AL = 2,
  AM = 3,
  AP = 4,
  BA = 5,
  CE = 6,
  DF = 7,
  ES = 8,
  GO = 9,
  MA = 10,
  MG = 11,
  MS = 12,
  MT = 13,
  PA = 14,
  PB = 15,
  PE = 16,
  PI = 17,
  PR = 18,
  RJ = 19,
  RN = 20,
  RO = 21,
  RR = 22,
  RS = 23,
  SC = 24,
  SE = 25,
  SP = 26,
  TO = 27,
}

export namespace EUF {
  export function toDisplay(arg: EUF): string {
    switch (arg) {
      case 0: return "";
      case 1: return "AC - Acre";
      case 2: return "AL - Alagoas";
      case 3: return "AM - Amazonas";
      case 4: return "AP - Amap&aacute;";
      case 5: return "BA - Bahia";
      case 6: return "CE - Cear&aacute;";
      case 7: return "DF - Distrito Federal";
      case 8: return "ES - Esp&iacute;rito Santo";
      case 9: return "GO - Goi&aacute;s";
      case 10: return "MA - Maranh&atilde;o";
      case 11: return "MG - Minas Gerais";
      case 12: return "MS - Mato Grosso do Sul";
      case 13: return "MT - Mato Grosso";
      case 14: return "PA - Par&aacute;";
      case 15: return "PB - Para&iacute;ba";
      case 16: return "PE - Pernanbuco";
      case 17: return "PI - Piau&iacute;";
      case 18: return "PR - Paran&aacute;";
      case 19: return "RJ - Rio de Janeiro";
      case 20: return "RN - Rio Grande do Norte";
      case 21: return "RO - Rondônia";
      case 22: return "RR - Roraima";
      case 23: return "RS - Rio Grande do Sul";
      case 24: return "SC - Santa Catarina";
      case 25: return "SE - Sergipe";
      case 26: return "SP - S&atilde;o Paulo";
      case 27: return "TO - Tocantins";
      default: return "";
    }
  }

  export function enums(): EUF[] {
    return [EUF.NONE,EUF.AC,EUF.AL,EUF.AM,EUF.AP,EUF.BA,EUF.CE,EUF.DF,EUF.ES,EUF.GO,EUF.MA,EUF.MG,EUF.MS,EUF.MT,EUF.PA,EUF.PB,EUF.PE,EUF.PI,EUF.PR,EUF.RJ,EUF.RN,EUF.RO,EUF.RR,EUF.RS,EUF.SC,EUF.SE,EUF.SP,EUF.TO];
  }
}


export class DataPageContext extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataPageContext";
}


export class DataArquivo extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataArquivo";
  nome: string = "";
  extensao: string = "";
  nomeEmDisco: string = "";
  path: string = "";

  constructor()
  constructor(nome: string, nomeEmDisco: string, extensao: string, path: string)
  constructor(nome?: string, nomeEmDisco?: string, extensao?: string, path?: string) {
    super();
    this.nome = nome || "";
    this.nomeEmDisco = nomeEmDisco || "";
    this.extensao = extensao || "";
    this.path = path || "";
  }

  public getPK(): DataArquivo {
    return new DataArquivo(this.nome, this.nomeEmDisco, this.extensao, this.path);
  }

  public equals(arg: DataArquivo): boolean {
    return arg 
        && (arg.nome === this.nome)
        && (arg.extensao === this.extensao)
        && (arg.nomeEmDisco === this.nomeEmDisco)
        && (arg.path === this.path)
    ;
  }
}


export class PKFuncionarioGerencia extends PKFuncionario {
  readonly jclass: string = "com.sollus.vo.PKFuncionarioGerencia";
  codEmpresaGerencia: number = 0;

  constructor()
  constructor(codEmpresa: number, codFuncionario: number, codEmpresaGerencia: number)
  constructor(codEmpresa?: number, codFuncionario?: number, codEmpresaGerencia?: number) {
    super();
    this.codEmpresa = codEmpresa || 0;
    this.codFuncionario = codFuncionario || 0;
    this.codEmpresaGerencia = codEmpresaGerencia || 0;
  }

  public getPK(): PKFuncionarioGerencia {
    return new PKFuncionarioGerencia(this.codEmpresa, this.codFuncionario, this.codEmpresaGerencia);
  }

  public equals(arg: PKFuncionarioGerencia): boolean {
    return arg && super.equals(arg)
        && (arg.codEmpresaGerencia === this.codEmpresaGerencia)
    ;
  }
}


export class PK extends BaseData {
  readonly jclass: string = "com.sollus.vo.PK";
  codigo: number = 0;

  constructor()
  constructor(codigo: number)
  constructor(codigo?: number) {
    super();
    this.codigo = codigo || 0;
  }

  public getPK(): PK {
    return new PK(this.codigo);
  }

  public equals(arg: PK): boolean {
    return arg 
        && (arg.codigo === this.codigo)
    ;
  }
}


export class DataCEP extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataCEP";
  bairro: string = "";
  cidade: string = "";
  codCEP: number = 0;
  codUF: string = "";
  logradouro: string = "";
  codIbgeMun: string = "";

  public getPK(): PK {
    let result: PK =  new PK();
    result.codigo = this.codCEP;
    return result;
  }

  public equals(arg: PK): boolean {
    return arg 
        && (arg.codigo === this.codCEP)
    ;
  }
}


export enum EArredondPrc {
  NONE = 0,
  ZERO = 1,
  CINQUENTA = 2,
  OITENTA = 3,
  OITO_NOVE = 9,
  NOVENTA = 4,
  NOV_CINCO = 7,
  NOV_OITO = 8,
  NOV_NOVE = 5,
  DEC_CENTAVOS = 6,
}

export namespace EArredondPrc {
  export function toDisplay(arg: EArredondPrc): string {
    switch (arg) {
      case 0: return "Nenhum";
      case 1: return "*,00";
      case 2: return "*,50";
      case 3: return "*,80";
      case 9: return "*,89";
      case 4: return "*,90";
      case 7: return "*,95";
      case 8: return "*,98";
      case 5: return "*,99";
      case 6: return "*,*0";
      default: return "";
    }
  }

  export function enums(): EArredondPrc[] {
    return [EArredondPrc.NONE,EArredondPrc.ZERO,EArredondPrc.CINQUENTA,EArredondPrc.OITENTA,EArredondPrc.OITO_NOVE,EArredondPrc.NOVENTA,EArredondPrc.NOV_CINCO,EArredondPrc.NOV_OITO,EArredondPrc.NOV_NOVE,EArredondPrc.DEC_CENTAVOS];
  }
}


export enum EPlanoVersaoLight {
  NONE = 0,
  AUTONOMO = 1,
  BASICO = 2,
  IDEAL = 3,
}

export namespace EPlanoVersaoLight {
  export function toDisplay(arg: EPlanoVersaoLight): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Autonomo";
      case 2: return "Basico";
      case 3: return "Ideal";
      default: return "";
    }
  }

  export function enums(): EPlanoVersaoLight[] {
    return [EPlanoVersaoLight.NONE,EPlanoVersaoLight.AUTONOMO,EPlanoVersaoLight.BASICO,EPlanoVersaoLight.IDEAL];
  }
}


export abstract class PKable {
  readonly jclass: string = "com.sollus.vo.PKable";
}


export enum ETipoCST51SPED {
  REDUCAO_BASE = 0,
  NORMAL = 1,
}

export namespace ETipoCST51SPED {
  export function toDisplay(arg: ETipoCST51SPED): string {
    switch (arg) {
      case 0: return "Informar o diferimento com base de calculo reduzida e CST 51";
      case 1: return "Informar o diferimento com a base de calculo cheia e CST 00";
      default: return "";
    }
  }

  export function enums(): ETipoCST51SPED[] {
    return [ETipoCST51SPED.REDUCAO_BASE,ETipoCST51SPED.NORMAL];
  }
}


export enum ETipoLicenca {
  NONE = 0,
  FULL = 1,
  LIGHT = 2,
  TRIAL = 3,
}

export namespace ETipoLicenca {
  export function toDisplay(arg: ETipoLicenca): string {
    switch (arg) {
      case 0: return "Informe";
      case 1: return "Controle FULL";
      case 2: return "Controle LIGHT";
      case 3: return "Trial";
      default: return "";
    }
  }

  export function enums(): ETipoLicenca[] {
    return [ETipoLicenca.NONE,ETipoLicenca.FULL,ETipoLicenca.LIGHT,ETipoLicenca.TRIAL];
  }
}


export class DataAmbiente extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataAmbiente";
  porta: string = "";
  basePath: string = "";
  nomeServidor: string = "";
  protocolo: string = "";
  ipServidor: string = "";
  contexto: string = "";

  constructor()
  constructor(protocolo: string, ipServidor: string, nomeServidor: string, porta: string, contexto: string)
  constructor(protocolo?: string, ipServidor?: string, nomeServidor?: string, porta?: string, contexto?: string) {
    super();
    this.protocolo = protocolo || "";
    this.ipServidor = ipServidor || "";
    this.nomeServidor = nomeServidor || "";
    this.porta = porta || "";
    this.contexto = contexto || "";
  }

  public getPK(): DataAmbiente {
    return new DataAmbiente(this.protocolo, this.ipServidor, this.nomeServidor, this.porta, this.contexto);
  }

  public equals(arg: DataAmbiente): boolean {
    return arg 
        && (arg.porta === this.porta)
        && (arg.basePath === this.basePath)
        && (arg.nomeServidor === this.nomeServidor)
        && (arg.protocolo === this.protocolo)
        && (arg.ipServidor === this.ipServidor)
        && (arg.contexto === this.contexto)
    ;
  }
}


export class DataEnderecoComp extends DataEndereco {
  readonly jclass: string = "com.sollus.vo.DataEnderecoComp";
  descricaoEndereco: string = "";
  infReferencia: string = "";
  retirarLoja: boolean = false;
}


export enum ETipoContaBancaria {
  NONE = 0,
  CONTA_CORRENTE = 1,
  CONTA_POUPANCA = 2,
}

export namespace ETipoContaBancaria {
  export function toDisplay(arg: ETipoContaBancaria): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Conta Corrente";
      case 2: return "Conta Poupan&ccedil;a";
      default: return "";
    }
  }

  export function enums(): ETipoContaBancaria[] {
    return [ETipoContaBancaria.NONE,ETipoContaBancaria.CONTA_CORRENTE,ETipoContaBancaria.CONTA_POUPANCA];
  }
}


export enum EPeriodo {
  HOJE = 0,
  ONTEM = 4,
  AMANHA = 10,
  SEMANA_ATUAL = 1,
  SEMANA_ANTERIOR = 5,
  SEMANA_PROXIMA = 11,
  MES_ATUAL = 2,
  MES_ANTERIOR = 6,
  MES_PROXIMO = 12,
  ULTIMOS_TRES_MESES = 8,
  ULTIMOS_DOZE_MESES = 18,
  PROXIMOS_TRES_MESES = 13,
  SEMESTRE_ATUAL = 14,
  SEMESTRE_ANTERIOR = 15,
  SEMESTRE_PROXIMO = 16,
  ANO_ATUAL = 3,
  ANO_ANTERIOR = 7,
  ANO_PROXIMO = 17,
  PERSONALIZADO = 9,
}

export namespace EPeriodo {
  export function toDisplay(arg: EPeriodo): string {
    switch (arg) {
      case 0: return "Hoje";
      case 4: return "Ontem";
      case 10: return "Amanh&amp;atilde;";
      case 1: return "Semana atual";
      case 5: return "Semana anterior";
      case 11: return "Pr&amp;oacute;xima semana";
      case 2: return "M&amp;ecirc;s atual";
      case 6: return "M&amp;ecirc;s anterior";
      case 12: return "Pr&amp;oacute;ximo m&amp;ecirc;s";
      case 8: return "&amp;Uacute;ltimos tr&amp;ecirc;s meses";
      case 18: return "&amp;Uacute;ltimos doze meses";
      case 13: return "Pr&amp;oacute;ximos tr&amp;ecirc;s meses";
      case 14: return "Semestre atual";
      case 15: return "Semestre anterior";
      case 16: return "Pr&amp;oacute;ximo semestre";
      case 3: return "Ano atual";
      case 7: return "Ano anterior";
      case 17: return "Pr&amp;oacute;ximo ano";
      case 9: return "Personalizado";
      default: return "";
    }
  }

  export function enums(): EPeriodo[] {
    return [EPeriodo.HOJE,EPeriodo.ONTEM,EPeriodo.AMANHA,EPeriodo.SEMANA_ATUAL,EPeriodo.SEMANA_ANTERIOR,EPeriodo.SEMANA_PROXIMA,EPeriodo.MES_ATUAL,EPeriodo.MES_ANTERIOR,EPeriodo.MES_PROXIMO,EPeriodo.ULTIMOS_TRES_MESES,EPeriodo.ULTIMOS_DOZE_MESES,EPeriodo.PROXIMOS_TRES_MESES,EPeriodo.SEMESTRE_ATUAL,EPeriodo.SEMESTRE_ANTERIOR,EPeriodo.SEMESTRE_PROXIMO,EPeriodo.ANO_ATUAL,EPeriodo.ANO_ANTERIOR,EPeriodo.ANO_PROXIMO,EPeriodo.PERSONALIZADO];
  }
}


export class BaseDataLogin extends BaseData {
  readonly jclass: string = "com.sollus.vo.BaseDataLogin";
  codUsuario: BaseData | undefined = undefined;
  dataRef: string = "";
  tfa: boolean = false;
  tfaCode: number = 0;
  codEmpresa: number = 0;
}


export enum ETipoPessoa {
  NONE = "",
  FISICA = "F",
  JURIDICA = "J",
}

export namespace ETipoPessoa {
  export function toDisplay(arg: ETipoPessoa): string {
    switch (arg) {
      case "": return "";
      case "F": return "F&iacute;sica";
      case "J": return "Jur&iacute;dica";
      default: return "";
    }
  }

  export function enums(): ETipoPessoa[] {
    return [ETipoPessoa.NONE,ETipoPessoa.FISICA,ETipoPessoa.JURIDICA];
  }
}


export enum ETipoVitrine {
  NONE = 0,
  PRIVADA = 1,
  PUBLICA = 2,
}

export namespace ETipoVitrine {
  export function toDisplay(arg: ETipoVitrine): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Privada";
      case 2: return "P&uacute;blica";
      default: return "";
    }
  }

  export function enums(): ETipoVitrine[] {
    return [ETipoVitrine.NONE,ETipoVitrine.PRIVADA,ETipoVitrine.PUBLICA];
  }
}


export class PKUUID extends BaseData {
  readonly jclass: string = "com.sollus.vo.PKUUID";
  codigo: string = "";

  constructor()
  constructor(codigo: string)
  constructor(codigo?: string) {
    super();
    this.codigo = codigo || "";
  }

  public getPK(): PKUUID {
    return new PKUUID(this.codigo);
  }

  public equals(arg: PKUUID): boolean {
    return arg 
        && (arg.codigo === this.codigo)
    ;
  }
}


export class PKStr extends BaseData {
  readonly jclass: string = "com.sollus.vo.PKStr";
  codigo: string = "";

  constructor()
  constructor(codigo: string)
  constructor(codigo?: string) {
    super();
    this.codigo = codigo || "";
  }

  public getPK(): PKStr {
    return new PKStr(this.codigo);
  }

  public equals(arg: PKStr): boolean {
    return arg 
        && (arg.codigo === this.codigo)
    ;
  }
}


export enum EStatusTask {
  NONE = 0,
  RUNNING = 1,
  WAITING = 2,
  ERROR = 3,
}

export namespace EStatusTask {
  export function toDisplay(arg: EStatusTask): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Correndo";
      case 2: return "Aguardando";
      case 3: return "Erro";
      default: return "";
    }
  }

  export function enums(): EStatusTask[] {
    return [EStatusTask.NONE,EStatusTask.RUNNING,EStatusTask.WAITING,EStatusTask.ERROR];
  }
}


export class DataRunnerInfo extends BaseData {
  readonly jclass: string = "com.sollus.model.runner.DataRunnerInfo";
  status: EStatusTask = EStatusTask.NONE;
  errMessage: string = "";
  name: string = "";
  ID: number = 0;

  constructor()
  constructor(ID: number, name: string, status: EStatusTask, errMessage: string)
  constructor(ID?: number, name?: string, status?: EStatusTask, errMessage?: string) {
    super();
    this.ID = ID || 0;
    this.name = name || "";
    this.status = status || EStatusTask.NONE;
    this.errMessage = errMessage || "";
  }

  public getPK(): DataRunnerInfo {
    return new DataRunnerInfo(this.ID, this.name, this.status, this.errMessage);
  }

  public equals(arg: DataRunnerInfo): boolean {
    return arg 
        && (arg.status === this.status)
        && (arg.errMessage === this.errMessage)
        && (arg.name === this.name)
        && (arg.ID === this.ID)
    ;
  }
}


export enum ETipoFone {
  NONE = 0,
  CELULAR = 1,
  CASA = 2,
  TRABALHO = 3,
  OUTRO = 99,
  ESTRANGEIRO = 100,
}

export namespace ETipoFone {
  export function toDisplay(arg: ETipoFone): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Celular";
      case 2: return "Casa";
      case 3: return "Trabalho";
      case 99: return "Outros";
      case 100: return "Estrangeiro";
      default: return "";
    }
  }

  export function enums(): ETipoFone[] {
    return [ETipoFone.NONE,ETipoFone.CELULAR,ETipoFone.CASA,ETipoFone.TRABALHO,ETipoFone.OUTRO,ETipoFone.ESTRANGEIRO];
  }
}


export enum EFilterBool {
  NONE = "''",
  SIM = "'S'",
  NAO = "'N'",
}

export namespace EFilterBool {
  export function toDisplay(arg: EFilterBool): string {
    switch (arg) {
      case "''": return "Todos";
      case "'S'": return "Sim";
      case "'N'": return "N&atilde;o";
      default: return "";
    }
  }

  export function enums(): EFilterBool[] {
    return [EFilterBool.NONE,EFilterBool.SIM,EFilterBool.NAO];
  }
}


export enum ETipoPagtoSite {
  NONE = 0,
  PAGSYS = 1,
  PAGSEGURO = 2,
  CIELO = 3,
  ITAU = 4,
  REDECARD = 5,
  MOOVIN = 6,
  PAGAR_ME = 7,
  CREDIARIO = 8,
  CONDICIONAL = 9,
  INTEGRACAO_WS = 10,
  LOJA = 11,
  MARKETPLACE = 12,
  SITEF = 13,
  ZOOP = 14,
  MACLE_PAGTO = 15,
}

export namespace ETipoPagtoSite {
  export function toDisplay(arg: ETipoPagtoSite): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Pagsys";
      case 2: return "Pag Seguro";
      case 3: return "Cielo";
      case 4: return "Itau";
      case 5: return "Redecard";
      case 6: return "Moovin";
      case 7: return "Pagar.me";
      case 8: return "Credi&aacute;rio";
      case 9: return "Condicional";
      case 10: return "Integra&ccedil;&atilde;o WS";
      case 11: return "Loja";
      case 12: return "Marketplace";
      case 13: return "SiTEF";
      case 14: return "ZOOP";
      case 15: return "MACLE Pagto";
      default: return "";
    }
  }

  export function enums(): ETipoPagtoSite[] {
    return [ETipoPagtoSite.NONE,ETipoPagtoSite.PAGSYS,ETipoPagtoSite.PAGSEGURO,ETipoPagtoSite.CIELO,ETipoPagtoSite.ITAU,ETipoPagtoSite.REDECARD,ETipoPagtoSite.MOOVIN,ETipoPagtoSite.PAGAR_ME,ETipoPagtoSite.CREDIARIO,ETipoPagtoSite.CONDICIONAL,ETipoPagtoSite.INTEGRACAO_WS,ETipoPagtoSite.LOJA,ETipoPagtoSite.MARKETPLACE,ETipoPagtoSite.SITEF,ETipoPagtoSite.ZOOP,ETipoPagtoSite.MACLE_PAGTO];
  }
}


export class BaseDataParamSistema extends BaseData {
  readonly jclass: string = "com.sollus.vo.BaseDataParamSistema";
  appImgPath: string = "";
  versaoBase: number = 0;
  numRecInPage: number = 0;
  imgContextName: string = "";
  appBasePath: string = "";
  idBase: number = 0;
}


export enum ESexo {
  NONE = "NULL",
  MASCULINO = "'M'",
  FEMININO = "'F'",
}

export namespace ESexo {
  export function toDisplay(arg: ESexo): string {
    switch (arg) {
      case "NULL": return "";
      case "'M'": return "Masculino";
      case "'F'": return "Feminino";
      default: return "";
    }
  }

  export function enums(): ESexo[] {
    return [ESexo.NONE,ESexo.MASCULINO,ESexo.FEMININO];
  }
}


export class DataServiceResponse extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataServiceResponse";
  pk: BaseData | undefined = undefined;
  mensagem: string = "";
}


export class DataErrorResp extends DataServiceResponse {
  readonly jclass: string = "com.sollus.vo.DataErrorResp";
  codigo: number = 0;
  errorClass: string = "";
  stackTrace: string[] = [];
}


export class DataLojaAPP extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataLojaAPP";
  bairro: string = "";
  cidade: string = "";
  cnpj: string = "";
  numero: string = "";
  CEP: number = 0;
  UF: string = "";
  fantasia: string = "";
  telefone: number = 0;
  logradouro: string = "";

  constructor()
  constructor(cnpj: string, fantasia: string, logradouro: string, numero: string, bairro: string, cidade: string, telefone: number, UF: string, CEP: number)
  constructor(cnpj?: string, fantasia?: string, logradouro?: string, numero?: string, bairro?: string, cidade?: string, telefone?: number, UF?: string, CEP?: number) {
    super();
    this.cnpj = cnpj || "";
    this.fantasia = fantasia || "";
    this.logradouro = logradouro || "";
    this.numero = numero || "";
    this.bairro = bairro || "";
    this.cidade = cidade || "";
    this.telefone = telefone || 0;
    this.UF = UF || "";
    this.CEP = CEP || 0;
  }

  public getPK(): DataLojaAPP {
    return new DataLojaAPP(this.cnpj, this.fantasia, this.logradouro, this.numero, this.bairro, this.cidade, this.telefone, this.UF, this.CEP);
  }

  public equals(arg: DataLojaAPP): boolean {
    return arg 
        && (arg.bairro === this.bairro)
        && (arg.cidade === this.cidade)
        && (arg.cnpj === this.cnpj)
        && (arg.numero === this.numero)
        && (arg.CEP === this.CEP)
        && (arg.UF === this.UF)
        && (arg.fantasia === this.fantasia)
        && (arg.telefone === this.telefone)
        && (arg.logradouro === this.logradouro)
    ;
  }
}


export class DataListaLojaAPP extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataListaLojaAPP";
  listLoja: ArrayList<DataLojaAPP> = new ArrayList<DataLojaAPP>(DataLojaAPP);
}


export enum EBancoFebraban {
  NONE = 0,
  BANCO_DO_BRASIL = 1,
  BANCO_DA_AMAZONIA = 2,
  BANCO_DO_NORDESTE = 3,
  BNDES = 4,
  CREDICOAMO = 5,
  CREDIT_SUISSE_HG = 6,
  BANCO_INBURSA = 7,
  STATE_STREET_BRASIL = 8,
  UBS_BRASIL_CCTVM = 9,
  CCM_DESP_TRANS_SC_RS = 10,
  BNY_MELLON = 11,
  BANCO_TRICURY = 12,
  BANCO_AZTECA = 13,
  BANESTES = 14,
  BANCO_BANDEPE = 15,
  BANCO_ALFA = 16,
  BANCO_ITAU_CONSIGNADO = 17,
  BANCO_SANTANDER = 18,
  BANCO_BRADESCO_BBI = 19,
  BANPARA = 20,
  BANCO_CARGILL = 21,
  BANRISUL = 22,
  BANESE = 23,
  CONFIDENCE_CC = 24,
  HIPERCARD = 25,
  BANCO_BRADESCARD = 26,
  BANCO_GOLDMAN_SACHS = 27,
  BANCO_ANDBANK = 28,
  BANCO_MORGAN_STANLEY = 29,
  BANCO_CREFISA = 30,
  BANCO_BRB = 31,
  BANCO_J_SAFRA = 32,
  BANCO_ABN_AMRO = 33,
  BANCO_KDB = 34,
  BANCO_INTER = 35,
  HAITONG_BI = 36,
  BANCO_ORIGINAL_AGRO = 37,
  BT_CORRETORA = 38,
  BANCO_SEGURO = 39,
  BANCO_TOPAZIO = 40,
  BANCO_DA_CHINA = 41,
  UNIPRIME_NORTE_PR = 42,
  AILOS = 43,
  CREDISAN = 44,
  UNICRED_CENTRAL_RS = 45,
  BRICKELL = 46,
  POLOCRED = 47,
  BANCO_FINAXIS = 48,
  TRAVELEX_BANCO = 49,
  BANCO_B3 = 50,
  CCC_NOROESTE_BRASILEIRO = 51,
  CREDIALIANCA = 52,
  UNIPRIME_CENTRAL = 53,
  PLANNER_CORRETORA = 54,
  RENASCENCA_DTVM = 55,
  XP_INVESTIMENTOS = 56,
  CAIXA_ECONOMICA_FEDERAL = 57,
  LECCA_CFI = 58,
  BANCO_BOCOM_BBM = 59,
  PORTOCRED = 60,
  OLIVEIRA_TRUST = 61,
  MAGLIANO = 62,
  CECOOP = 63,
  ADVANCED_CC = 64,
  STANDARD_CHARTERED = 65,
  BANCO_WESTERN_UNION = 66,
  BANCO_RODOBENS = 67,
  BANCO_AGIBANK = 68,
  BANCO_BRADESCO_BERJ = 69,
  BANCO_WOORI = 70,
  BRASIL_PLURAL = 71,
  BR_PARTNERS = 72,
  CODEPE = 73,
  MS_BANK = 74,
  UBS_BRASIL_BI = 75,
  CARUANA = 76,
  TULLETT_PREBON = 77,
  ICBC_BRASIL = 78,
  CRESOL = 79,
  BGC_LIQUIDEZ = 80,
  UNICRED = 81,
  MULTIMONEY = 82,
  GET_MONEY = 83,
  INTESA_SANPAOLO = 84,
  EASYNVEST = 85,
  BROKER_BRASIL = 86,
  TREVISO = 87,
  BEXS_BANCO = 88,
  LEVYCAM = 89,
  GUITTA = 90,
  FACTA = 91,
  ICAP_BRASIL = 92,
  CASA_DO_CREDITO = 93,
  COMMERZBANK = 94,
  BANCO_OLE_BONSUCESSO = 95,
  BRL_TRUST = 96,
  PERNAMBUCANAS = 97,
  GUIDE_INVESTIMENTOS = 98,
  CM_CAPITAL = 99,
  SOCRED = 100,
  BANCO_ITAU_BBA = 101,
  ATIVA_INVESTIMENTOS = 102,
  HS_FINANCEIRA = 103,
  SERVICOOP = 104,
  NOVA_FUTURA = 105,
  PARMETAL = 106,
  FAIR_CC = 107,
  STONE = 108,
  BANCO_BTG_PACTUAL = 109,
  BANCO_ORIGINAL = 110,
  BANCO_ARBI = 111,
  BANCO_JOHN_DEERE = 112,
  BANCO_BS2 = 113,
  BANCO_CREDIT_AGRICOLE = 114,
  BANCO_FIBRA = 115,
  BANCO_CRUZEIRO_DO_SUL = 116,
  UNICARD = 117,
  BANCO_CIFRA = 118,
  BANCO_BRADESCO = 119,
  BANCO_CLASSICO = 120,
  BANCO_MAXIMA = 121,
  BANCO_ABC_BRASIL = 122,
  BANCO_INVESTCRED = 123,
  BCV = 124,
  BEXS_CORRETORA = 125,
  PARANA_BANCO = 126,
  NUBANK = 127,
  BANCO_CEDULA = 128,
  BARIGUI = 129,
  CCR_SAO_MIGUEL = 130,
  CCR_PRIMAVERA = 131,
  AVISTA = 132,
  CCR_OURO = 133,
  PAGBANK = 134,
  VIPS_CC = 135,
  BPP = 136,
  BANCO_LA_NACION = 137,
  VORTX = 138,
  BANCO_BMG = 139,
  BANCO_CCB_BRASIL = 140,
  MERCADO_PAGO = 141,
  BANCO_DIGIO = 142,
  BANCO_C6 = 143,
  ITAU_UNIBANCO = 144,
  BANCO_XP = 145,
  BANCO_BRADESCO_FINANCIAMENTOS = 146,
  PICPAY = 147,
  BANCO_MERCANTIL_DO_BRASIL = 148,
  BANCO_VOLKSWAGEN = 149,
  KIRTON_BANK = 150,
  CORA = 151,
  BANCO_CAPITAL = 152,
  BANCO_BV = 153,
  BANCO_SAFRA = 154,
  BANCO_MUFG = 155,
  BANCO_SUMITOMO_MITSUI = 156,
  CITIBANK_NA = 157,
  BANCO_DEUTSCHE_BANK = 158,
  JPMORGAN_CHASE = 159,
  BANCO_ING = 160,
  BANCO_CREDIT_SUISSE = 161,
  BANCO_LUSO_BRASILEIRO = 162,
  BANCO_INDUSTRIAL_DO_BRASIL = 163,
  BANCO_VR = 164,
  BANCO_PAULISTA = 165,
  BANCO_GUANABARA = 166,
  BANCO_PAN = 167,
  BANCO_FICSA = 168,
  BANCO_RENDIMENTO = 169,
  BANCO_TRIANGULO = 170,
  BANCO_SOFISA = 171,
  BANCO_ALVORADA = 172,
  BANCO_PINE = 173,
  BANCO_INDUSVAL = 174,
  BANCO_NEON = 175,
  BANCO_DAYCOVAL = 176,
  BANCO_OURINVEST = 177,
  BANCO_BANIF = 178,
  BANCO_MAXINVEST = 179,
  BANCO_RIBEIRAO_PRETO = 180,
  BANCO_SEMEAR = 181,
  BANCO_CITIBANK = 182,
  BANCO_MODAL = 183,
  BANCO_RABOBANK = 184,
  BANCO_COOPERATIVO_SICREDI = 185,
  SCOTIABANK = 186,
  BANCO_BNP_PARIBAS = 187,
  BANCO_COOPERATIVO_SICOOB = 188,
  BANCO_KEB_HANA = 189,
  BANCO_FATOR = 190,
  BANCO_SOCIETE_GENERALE = 191,
  BANCO_MIZUHO = 192,
  BANCO_JP_MORGAN = 193,
  BANCO_CETELEM = 194,
  BANCO_GERDAU = 195,
}

export namespace EBancoFebraban {
  export function toDisplay(arg: EBancoFebraban): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Banco do Brasil S.A.";
      case 2: return "Banco da Amazônia S.A.";
      case 3: return "Banco do Nordeste do Brasil S.A.";
      case 4: return "Banco Nacional de Desenvolvimento Econômico e Social ? BNDES";
      case 5: return "Credicoamo Cr&eacute;dito Rural Cooperativa";
      case 6: return "Credit Suisse Hedging-Griffo Corretora de Valores S.A.";
      case 7: return "Banco Inbursa S.A.";
      case 8: return "State Street Brasil S.A. ? Banco Comercial";
      case 9: return "UBS Brasil Corretora de C&acirc;mbio, T&iacute;tulos e Valores Mobili&aacute;rios S.A.";
      case 10: return "Cooperativa de Cr&eacute;dito M&uacute;tuo dos Despachantes de Tr&acirc;nsito de SC e RS";
      case 11: return "BNY Mellon Banco S.A.";
      case 12: return "Banco Tricury S.A.";
      case 13: return "Banco Azteca do Brasil S.A.";
      case 14: return "BANESTES S.A. Banco do Estado do Esp&iacute;rito Santo";
      case 15: return "Banco BANDEPE S.A.";
      case 16: return "Banco Alfa S.A.";
      case 17: return "Banco Ita&uacute; Consignado S.A.";
      case 18: return "Banco Santander (Brasil) S.A.";
      case 19: return "Banco Bradesco BBI S.A.";
      case 20: return "Banco do Estado do Par&aacute; S.A.";
      case 21: return "Banco Cargill S.A.";
      case 22: return "Banco do Estado do Rio Grande do Sul S.A.";
      case 23: return "Banco do Estado de Sergipe S.A.";
      case 24: return "Confidence Corretora de C&acirc;mbio S.A.";
      case 25: return "Hipercard Banco M&uacute;ltiplo S.A.";
      case 26: return "Banco Bradescard S.A.";
      case 27: return "Goldman Sachs do Brasil Banco M&uacute;ltiplo S.A.";
      case 28: return "Banco Andbank (Brasil) S.A.";
      case 29: return "Banco Morgan Stanley S.A.";
      case 30: return "Banco Crefisa S.A.";
      case 31: return "BRB ? Banco de Bras&iacute;lia S.A.";
      case 32: return "Banco J. Safra S.A.";
      case 33: return "Banco ABN AMRO S.A.";
      case 34: return "Banco KDB S.A.";
      case 35: return "Banco Inter S.A.";
      case 36: return "Haitong Banco de Investimento do Brasil S.A.";
      case 37: return "Banco Original do Agroneg&oacute;cio S.A.";
      case 38: return "B&amp;T Corretora de C&acirc;mbio Ltda.";
      case 39: return "BancoSeguro S.A.";
      case 40: return "Banco Top&aacute;zio S.A.";
      case 41: return "Banco da China Brasil S.A.";
      case 42: return "Uniprime Norte do Paran&aacute; ? Coop de Economia e Cr&eacute;dito M&uacute;tuo dos M&eacute;dicos";
      case 43: return "Cooperativa Central de Cr&eacute;dito ? AILOS";
      case 44: return "Credisan Cooperativa de Cr&eacute;dito";
      case 45: return "Central de Cooperativas de Economia e Cr&eacute;dito M&uacute;tuo do RS";
      case 46: return "Brickell S.A. Cr&eacute;dito";
      case 47: return "P&oacute;locred Sociedade de Cr&eacute;dito ao Microempreendedor";
      case 48: return "Banco Finaxis S.A.";
      case 49: return "Travelex Banco de C&acirc;mbio S.A.";
      case 50: return "Banco B3 S.A.";
      case 51: return "Cooperativa Central de Cr&eacute;dito Noroeste Brasileiro Ltda.";
      case 52: return "Credialian&ccedil;a Cooperativa de Cr&eacute;dito Rural";
      case 53: return "Uniprime Central ? Central Interestadual de Cooperativas de Cr&eacute;dito Ltda.";
      case 54: return "Planner Corretora de Valores S.A.";
      case 55: return "Renascen&ccedil;a Distribuidora de T&iacute;tulos e Valores Mobili&aacute;rios Ltda.";
      case 56: return "XP Investimentos Corretora de C&acirc;mbio, T&iacute;tulos e Valores Mobili&aacute;rios S/A";
      case 57: return "Caixa Econômica Federal";
      case 58: return "Lecca Cr&eacute;dito, Financiamento e Investimento S/A";
      case 59: return "Banco BOCOM BBM S.A.";
      case 60: return "Portocred S.A. ? Cr&eacute;dito, Financiamento e Investimento";
      case 61: return "Oliveira Trust Distribuidora de T&iacute;tulos e Valores Mobili&aacute;rios S.A.";
      case 62: return "Magliano S.A. Corretora de C&acirc;mbio e Valores Mobili&aacute;rios";
      case 63: return "Central Cooperativa de Cr&eacute;dito no Estado do Esp&iacute;rito Santo ? CECOOP";
      case 64: return "Advanced Corretora de C&acirc;mbio Ltda.";
      case 65: return "Standard Chartered Bank (Brasil) S.A.";
      case 66: return "Banco Western Union do Brasil S.A.";
      case 67: return "Banco Rodobens S.A.";
      case 68: return "Banco Agibank S.A.";
      case 69: return "Banco Bradesco BERJ S.A.";
      case 70: return "Banco Woori Bank do Brasil S.A.";
      case 71: return "Plural S.A. ? Banco M&uacute;ltiplo";
      case 72: return "BR Partners Banco de Investimento S.A.";
      case 73: return "Codepe Corretora de Valores e C&acirc;mbio S.A.";
      case 74: return "MS Bank S.A. Banco de C&acirc;mbio";
      case 75: return "UBS Brasil Banco de Investimento S.A.";
      case 76: return "Caruana S.A. ? Sociedade de Cr&eacute;dito, Financiamento e Investimento";
      case 77: return "Tullett Prebon Brasil Corretora de Valores e C&acirc;mbio Ltda.";
      case 78: return "ICBC do Brasil Banco M&uacute;ltiplo S.A.";
      case 79: return "Cresol Confedera&ccedil;&atilde;o";
      case 80: return "BGC Liquidez Distribuidora de T&iacute;tulos e Valores Mobili&aacute;rios Ltda.";
      case 81: return "Confedera&ccedil;&atilde;o Nacional das Cooperativas Centrais Unicred Ltda. ? Unicred do Brasil";
      case 82: return "Multimoney Corretora de C&acirc;mbio Ltda.";
      case 83: return "Get Money Corretora de C&acirc;mbio S.A.";
      case 84: return "Intesa Sanpaolo Brasil S.A. ? Banco M&uacute;ltiplo";
      case 85: return "Easynvest ? T&iacute;tulo Corretora de Valores SA";
      case 86: return "Broker Brasil Corretora de C&acirc;mbio Ltda.";
      case 87: return "Treviso Corretora de C&acirc;mbio S.A.";
      case 88: return "BEXS Banco de C&acirc;mbio S.A.";
      case 89: return "Levycam ? Corretora de C&acirc;mbio e Valores Ltda.";
      case 90: return "Guitta Corretora de C&acirc;mbio Ltda.";
      case 91: return "Facta Financeira S.A. ? Cr&eacute;dito Financiamento e Investimento";
      case 92: return "ICAP do Brasil Corretora de T&iacute;tulos e Valores Mobili&aacute;rios Ltda.";
      case 93: return "Casa do Cr&eacute;dito S.A. Sociedade de Cr&eacute;dito ao Microempreendedor";
      case 94: return "Commerzbank Brasil S.A. ? Banco M&uacute;ltiplo";
      case 95: return "Banco Ol&eacute; Bonsucesso Consignado S.A.";
      case 96: return "BRL Trust Distribuidora de T&iacute;tulos e Valores Mobili&aacute;rios S.A.";
      case 97: return "Pernambucanas Financiadora S.A. ? Cr&eacute;dito, Financiamento e Investimento";
      case 98: return "Guide Investimentos S.A. Corretora de Valores";
      case 99: return "CM Capital Markets Corretora de C&acirc;mbio, T&iacute;tulos e Valores Mobili&aacute;rios Ltda.";
      case 100: return "Socred S.A. ? Sociedade de Cr&eacute;dito ao Microempreendedor";
      case 101: return "Banco Ita&uacute; BBA S.A.";
      case 102: return "Ativa Investimentos S.A. Corretora de T&iacute;tulos, C&acirc;mbio e Valores";
      case 103: return "HS Financeira S/A Cr&eacute;dito, Financiamento e Investimentos";
      case 104: return "Servicoop ? Cooperativa de Cr&eacute;dito dos Servidores P&uacute;blicos Estaduais do RS";
      case 105: return "Nova Futura Corretora de T&iacute;tulos e Valores Mobili&aacute;rios Ltda.";
      case 106: return "Parmetal Distribuidora de T&iacute;tulos e Valores Mobili&aacute;rios Ltda.";
      case 107: return "Fair Corretora de C&acirc;mbio S.A.";
      case 108: return "Stone Pagamentos S.A.";
      case 109: return "Banco BTG Pactual S.A.";
      case 110: return "Banco Original S.A.";
      case 111: return "Banco Arbi S.A.";
      case 112: return "Banco John Deere S.A.";
      case 113: return "Banco BS2 S.A.";
      case 114: return "Banco Credit Agricole Brasil S.A.";
      case 115: return "Banco Fibra S.A.";
      case 116: return "Banco Cruzeiro do Sul S.A.";
      case 117: return "Unicard Banco M&uacute;ltiplo S.A.";
      case 118: return "Banco Cifra S.A.";
      case 119: return "Banco Bradesco S.A.";
      case 120: return "Banco Cl&aacute;ssico S.A.";
      case 121: return "Banco M&aacute;xima S.A.";
      case 122: return "Banco ABC Brasil S.A.";
      case 123: return "Banco Investcred Unibanco S.A.";
      case 124: return "BCV ? Banco de Cr&eacute;dito e Varejo S.A.";
      case 125: return "Bexs Corretora de C&acirc;mbio S/A";
      case 126: return "Paran&aacute; Banco S.A.";
      case 127: return "Nu Pagamentos S.A.";
      case 128: return "Banco C&eacute;dula S.A.";
      case 129: return "Barigui Companhia Hipotec&aacute;ria";
      case 130: return "CCR de S&atilde;o Miguel do Oeste";
      case 131: return "CCR de Primavera do Leste";
      case 132: return "Avista S.A. Cr&eacute;dito, Financiamento e Investimento";
      case 133: return "CCR de Ouro";
      case 134: return "Pagseguro Internet S.A. (PagBank)";
      case 135: return "Vips Corretora de C&acirc;mbio Ltda.";
      case 136: return "BPP Institui&ccedil;&atilde;o de Pagamentos S.A.";
      case 137: return "Banco de La Naci&oacute;n Argentina";
      case 138: return "Vortx Distribuidora de T&iacute;tulos e Valores Mobili&aacute;rios Ltda.";
      case 139: return "Banco BMG S.A.";
      case 140: return "Banco CCB Brasil S.A.";
      case 141: return "Mercado Pago";
      case 142: return "Banco Digio S.A.";
      case 143: return "Banco C6 S.A.";
      case 144: return "Ita&uacute; Unibanco S.A.";
      case 145: return "Banco XP S.A.";
      case 146: return "Banco Bradesco Financiamentos S.A.";
      case 147: return "PicPay Servi&ccedil;os S.A.";
      case 148: return "Banco Mercantil do Brasil S.A.";
      case 149: return "Banco Volkswagen S.A.";
      case 150: return "Kirton Bank S.A. ? Banco M&uacute;ltiplo";
      case 151: return "Cora SCD S.A.";
      case 152: return "Banco Capital S.A.";
      case 153: return "Banco BV S.A.";
      case 154: return "Banco Safra S.A.";
      case 155: return "Banco de Tokyo-Mitsubishi UFJ Brasil S.A.";
      case 156: return "Banco Sumitomo Mitsui Brasileiro S.A.";
      case 157: return "Citibank N.A.";
      case 158: return "Deutsche Bank S.A. ? Banco Alem&atilde;o";
      case 159: return "JPMorgan Chase Bank, National Association";
      case 160: return "ING Bank N.V.";
      case 161: return "Banco Credit Suisse (Brasil) S.A.";
      case 162: return "Banco Luso Brasileiro S.A.";
      case 163: return "Banco Industrial do Brasil S.A.";
      case 164: return "Banco VR S.A.";
      case 165: return "Banco Paulista S.A.";
      case 166: return "Banco Guanabara S.A.";
      case 167: return "Banco Pan S.A.";
      case 168: return "Banco Ficsa S.A.";
      case 169: return "Banco Rendimento S.A.";
      case 170: return "Banco Tri&acirc;ngulo S.A.";
      case 171: return "Banco Sofisa S.A.";
      case 172: return "Banco Alvorada S.A.";
      case 173: return "Banco Pine S.A.";
      case 174: return "Banco Indusval S.A.";
      case 175: return "Neon Pagamentos S.A.";
      case 176: return "Banco Daycoval S.A.";
      case 177: return "Banco Ourinvest S.A.";
      case 178: return "Banco Banif Brasil S.A.";
      case 179: return "Banco Maxinvest S.A.";
      case 180: return "Banco Ribeir&atilde;o Preto S.A.";
      case 181: return "Banco Semear S.A.";
      case 182: return "Banco Citibank S.A.";
      case 183: return "Banco Modal S.A.";
      case 184: return "Banco Rabobank International Brasil S.A.";
      case 185: return "Banco Cooperativo Sicredi S.A.";
      case 186: return "Scotiabank Brasil S.A. Banco M&uacute;ltiplo";
      case 187: return "Banco BNP Paribas Brasil S.A.";
      case 188: return "Banco Cooperativo Sicoob S.A.";
      case 189: return "Banco KEB Hana do Brasil S.A.";
      case 190: return "Banco Fator S.A.";
      case 191: return "Banco Soci&eacute;t&eacute; G&eacute;n&eacute;rale Brasil S.A.";
      case 192: return "Banco Mizuho do Brasil S.A.";
      case 193: return "Banco J.P. Morgan S.A.";
      case 194: return "Banco Cetelem S.A.";
      case 195: return "Banco Gerdau S.A.";
      default: return "";
    }
  }

  export function enums(): EBancoFebraban[] {
    return [EBancoFebraban.NONE,EBancoFebraban.BANCO_DO_BRASIL,EBancoFebraban.BANCO_DA_AMAZONIA,EBancoFebraban.BANCO_DO_NORDESTE,EBancoFebraban.BNDES,EBancoFebraban.CREDICOAMO,EBancoFebraban.CREDIT_SUISSE_HG,EBancoFebraban.BANCO_INBURSA,EBancoFebraban.STATE_STREET_BRASIL,EBancoFebraban.UBS_BRASIL_CCTVM,EBancoFebraban.CCM_DESP_TRANS_SC_RS,EBancoFebraban.BNY_MELLON,EBancoFebraban.BANCO_TRICURY,EBancoFebraban.BANCO_AZTECA,EBancoFebraban.BANESTES,EBancoFebraban.BANCO_BANDEPE,EBancoFebraban.BANCO_ALFA,EBancoFebraban.BANCO_ITAU_CONSIGNADO,EBancoFebraban.BANCO_SANTANDER,EBancoFebraban.BANCO_BRADESCO_BBI,EBancoFebraban.BANPARA,EBancoFebraban.BANCO_CARGILL,EBancoFebraban.BANRISUL,EBancoFebraban.BANESE,EBancoFebraban.CONFIDENCE_CC,EBancoFebraban.HIPERCARD,EBancoFebraban.BANCO_BRADESCARD,EBancoFebraban.BANCO_GOLDMAN_SACHS,EBancoFebraban.BANCO_ANDBANK,EBancoFebraban.BANCO_MORGAN_STANLEY,EBancoFebraban.BANCO_CREFISA,EBancoFebraban.BANCO_BRB,EBancoFebraban.BANCO_J_SAFRA,EBancoFebraban.BANCO_ABN_AMRO,EBancoFebraban.BANCO_KDB,EBancoFebraban.BANCO_INTER,EBancoFebraban.HAITONG_BI,EBancoFebraban.BANCO_ORIGINAL_AGRO,EBancoFebraban.BT_CORRETORA,EBancoFebraban.BANCO_SEGURO,EBancoFebraban.BANCO_TOPAZIO,EBancoFebraban.BANCO_DA_CHINA,EBancoFebraban.UNIPRIME_NORTE_PR,EBancoFebraban.AILOS,EBancoFebraban.CREDISAN,EBancoFebraban.UNICRED_CENTRAL_RS,EBancoFebraban.BRICKELL,EBancoFebraban.POLOCRED,EBancoFebraban.BANCO_FINAXIS,EBancoFebraban.TRAVELEX_BANCO,EBancoFebraban.BANCO_B3,EBancoFebraban.CCC_NOROESTE_BRASILEIRO,EBancoFebraban.CREDIALIANCA,EBancoFebraban.UNIPRIME_CENTRAL,EBancoFebraban.PLANNER_CORRETORA,EBancoFebraban.RENASCENCA_DTVM,EBancoFebraban.XP_INVESTIMENTOS,EBancoFebraban.CAIXA_ECONOMICA_FEDERAL,EBancoFebraban.LECCA_CFI,EBancoFebraban.BANCO_BOCOM_BBM,EBancoFebraban.PORTOCRED,EBancoFebraban.OLIVEIRA_TRUST,EBancoFebraban.MAGLIANO,EBancoFebraban.CECOOP,EBancoFebraban.ADVANCED_CC,EBancoFebraban.STANDARD_CHARTERED,EBancoFebraban.BANCO_WESTERN_UNION,EBancoFebraban.BANCO_RODOBENS,EBancoFebraban.BANCO_AGIBANK,EBancoFebraban.BANCO_BRADESCO_BERJ,EBancoFebraban.BANCO_WOORI,EBancoFebraban.BRASIL_PLURAL,EBancoFebraban.BR_PARTNERS,EBancoFebraban.CODEPE,EBancoFebraban.MS_BANK,EBancoFebraban.UBS_BRASIL_BI,EBancoFebraban.CARUANA,EBancoFebraban.TULLETT_PREBON,EBancoFebraban.ICBC_BRASIL,EBancoFebraban.CRESOL,EBancoFebraban.BGC_LIQUIDEZ,EBancoFebraban.UNICRED,EBancoFebraban.MULTIMONEY,EBancoFebraban.GET_MONEY,EBancoFebraban.INTESA_SANPAOLO,EBancoFebraban.EASYNVEST,EBancoFebraban.BROKER_BRASIL,EBancoFebraban.TREVISO,EBancoFebraban.BEXS_BANCO,EBancoFebraban.LEVYCAM,EBancoFebraban.GUITTA,EBancoFebraban.FACTA,EBancoFebraban.ICAP_BRASIL,EBancoFebraban.CASA_DO_CREDITO,EBancoFebraban.COMMERZBANK,EBancoFebraban.BANCO_OLE_BONSUCESSO,EBancoFebraban.BRL_TRUST,EBancoFebraban.PERNAMBUCANAS,EBancoFebraban.GUIDE_INVESTIMENTOS,EBancoFebraban.CM_CAPITAL,EBancoFebraban.SOCRED,EBancoFebraban.BANCO_ITAU_BBA,EBancoFebraban.ATIVA_INVESTIMENTOS,EBancoFebraban.HS_FINANCEIRA,EBancoFebraban.SERVICOOP,EBancoFebraban.NOVA_FUTURA,EBancoFebraban.PARMETAL,EBancoFebraban.FAIR_CC,EBancoFebraban.STONE,EBancoFebraban.BANCO_BTG_PACTUAL,EBancoFebraban.BANCO_ORIGINAL,EBancoFebraban.BANCO_ARBI,EBancoFebraban.BANCO_JOHN_DEERE,EBancoFebraban.BANCO_BS2,EBancoFebraban.BANCO_CREDIT_AGRICOLE,EBancoFebraban.BANCO_FIBRA,EBancoFebraban.BANCO_CRUZEIRO_DO_SUL,EBancoFebraban.UNICARD,EBancoFebraban.BANCO_CIFRA,EBancoFebraban.BANCO_BRADESCO,EBancoFebraban.BANCO_CLASSICO,EBancoFebraban.BANCO_MAXIMA,EBancoFebraban.BANCO_ABC_BRASIL,EBancoFebraban.BANCO_INVESTCRED,EBancoFebraban.BCV,EBancoFebraban.BEXS_CORRETORA,EBancoFebraban.PARANA_BANCO,EBancoFebraban.NUBANK,EBancoFebraban.BANCO_CEDULA,EBancoFebraban.BARIGUI,EBancoFebraban.CCR_SAO_MIGUEL,EBancoFebraban.CCR_PRIMAVERA,EBancoFebraban.AVISTA,EBancoFebraban.CCR_OURO,EBancoFebraban.PAGBANK,EBancoFebraban.VIPS_CC,EBancoFebraban.BPP,EBancoFebraban.BANCO_LA_NACION,EBancoFebraban.VORTX,EBancoFebraban.BANCO_BMG,EBancoFebraban.BANCO_CCB_BRASIL,EBancoFebraban.MERCADO_PAGO,EBancoFebraban.BANCO_DIGIO,EBancoFebraban.BANCO_C6,EBancoFebraban.ITAU_UNIBANCO,EBancoFebraban.BANCO_XP,EBancoFebraban.BANCO_BRADESCO_FINANCIAMENTOS,EBancoFebraban.PICPAY,EBancoFebraban.BANCO_MERCANTIL_DO_BRASIL,EBancoFebraban.BANCO_VOLKSWAGEN,EBancoFebraban.KIRTON_BANK,EBancoFebraban.CORA,EBancoFebraban.BANCO_CAPITAL,EBancoFebraban.BANCO_BV,EBancoFebraban.BANCO_SAFRA,EBancoFebraban.BANCO_MUFG,EBancoFebraban.BANCO_SUMITOMO_MITSUI,EBancoFebraban.CITIBANK_NA,EBancoFebraban.BANCO_DEUTSCHE_BANK,EBancoFebraban.JPMORGAN_CHASE,EBancoFebraban.BANCO_ING,EBancoFebraban.BANCO_CREDIT_SUISSE,EBancoFebraban.BANCO_LUSO_BRASILEIRO,EBancoFebraban.BANCO_INDUSTRIAL_DO_BRASIL,EBancoFebraban.BANCO_VR,EBancoFebraban.BANCO_PAULISTA,EBancoFebraban.BANCO_GUANABARA,EBancoFebraban.BANCO_PAN,EBancoFebraban.BANCO_FICSA,EBancoFebraban.BANCO_RENDIMENTO,EBancoFebraban.BANCO_TRIANGULO,EBancoFebraban.BANCO_SOFISA,EBancoFebraban.BANCO_ALVORADA,EBancoFebraban.BANCO_PINE,EBancoFebraban.BANCO_INDUSVAL,EBancoFebraban.BANCO_NEON,EBancoFebraban.BANCO_DAYCOVAL,EBancoFebraban.BANCO_OURINVEST,EBancoFebraban.BANCO_BANIF,EBancoFebraban.BANCO_MAXINVEST,EBancoFebraban.BANCO_RIBEIRAO_PRETO,EBancoFebraban.BANCO_SEMEAR,EBancoFebraban.BANCO_CITIBANK,EBancoFebraban.BANCO_MODAL,EBancoFebraban.BANCO_RABOBANK,EBancoFebraban.BANCO_COOPERATIVO_SICREDI,EBancoFebraban.SCOTIABANK,EBancoFebraban.BANCO_BNP_PARIBAS,EBancoFebraban.BANCO_COOPERATIVO_SICOOB,EBancoFebraban.BANCO_KEB_HANA,EBancoFebraban.BANCO_FATOR,EBancoFebraban.BANCO_SOCIETE_GENERALE,EBancoFebraban.BANCO_MIZUHO,EBancoFebraban.BANCO_JP_MORGAN,EBancoFebraban.BANCO_CETELEM,EBancoFebraban.BANCO_GERDAU];
  }
}


export enum ERamoAtividade {
  NONE = 0,
  CALCADO_CONFECCAO = 1,
  ELETRO_MOVEIS = 2,
  OTICA = 3,
}

export namespace ERamoAtividade {
  export function toDisplay(arg: ERamoAtividade): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Cal&ccedil;ado Confec&ccedil;&atilde;o";
      case 2: return "El&eacute;tro M&oacute;veis";
      case 3: return "&Oacute;tica";
      default: return "";
    }
  }

  export function enums(): ERamoAtividade[] {
    return [ERamoAtividade.NONE,ERamoAtividade.CALCADO_CONFECCAO,ERamoAtividade.ELETRO_MOVEIS,ERamoAtividade.OTICA];
  }
}


export enum ERegimeTributario {
  NONE = 0,
  NORMAL = 3,
  LUCRO_PRESUMIDO = 5,
  SIMPLES_NACIONAL = 1,
}

export namespace ERegimeTributario {
  export function toDisplay(arg: ERegimeTributario): string {
    switch (arg) {
      case 0: return "-- Informe --";
      case 3: return "Lucro Real";
      case 5: return "Lucro Presumido";
      case 1: return "Simples Nacional";
      default: return "";
    }
  }

  export function enums(): ERegimeTributario[] {
    return [ERegimeTributario.NONE,ERegimeTributario.NORMAL,ERegimeTributario.LUCRO_PRESUMIDO,ERegimeTributario.SIMPLES_NACIONAL];
  }
}


export class PeriodoMes extends BaseData {
  readonly jclass: string = "com.sollus.vo.PeriodoMes";
  meses: number = 0;
}


export enum EAmbienteVitrine {
  NONE = 0,
  DEDICADO = 1,
  COMPARTILHADO = 2,
}

export namespace EAmbienteVitrine {
  export function toDisplay(arg: EAmbienteVitrine): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Dedicado";
      case 2: return "Compartilhado";
      default: return "";
    }
  }

  export function enums(): EAmbienteVitrine[] {
    return [EAmbienteVitrine.NONE,EAmbienteVitrine.DEDICADO,EAmbienteVitrine.COMPARTILHADO];
  }
}


export enum EIndSincNFe {
  ASSINCRONO = 0,
  SINCRONO = 1,
}

export namespace EIndSincNFe {
  export function toDisplay(arg: EIndSincNFe): string {
    switch (arg) {
      case 0: return "Assincrono";
      case 1: return "Sincrono";
      default: return "";
    }
  }

  export function enums(): EIndSincNFe[] {
    return [EIndSincNFe.ASSINCRONO,EIndSincNFe.SINCRONO];
  }
}


export class FilterLOG extends BaseData {
  readonly jclass: string = "com.sollus.vo.FilterLOG";
  entidade: number = 0;
  acao: number = 0;
  usuario: PKFuncionario = new PKFuncionario();
  dataIni: string = "";
  dataFim: string = "";
  repl: EFilterBool = EFilterBool.NONE;
}


export enum ETipoFrete {
  NONE = 0,
  SEDEX = 1,
  PAC = 2,
  ENVIO_FLEX_ML = 3,
  TRANSPORTADORA = 4,
}

export namespace ETipoFrete {
  export function toDisplay(arg: ETipoFrete): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Sedex";
      case 2: return "Encomenda PAC";
      case 3: return "Envio Flex";
      case 4: return "Transporadora";
      default: return "";
    }
  }

  export function enums(): ETipoFrete[] {
    return [ETipoFrete.NONE,ETipoFrete.SEDEX,ETipoFrete.PAC,ETipoFrete.ENVIO_FLEX_ML,ETipoFrete.TRANSPORTADORA];
  }
}


export enum ETipoPeriodo {
  NONE = 0,
  ANTERIOR = 1,
  COMPLETO = 2,
  POSTERIOR = 3,
}

export namespace ETipoPeriodo {
  export function toDisplay(arg: ETipoPeriodo): string {
    switch (arg) {
      case 0: return "Personalizado";
      case 1: return "Anterior";
      case 2: return "Completo";
      case 3: return "Posterior";
      default: return "";
    }
  }

  export function enums(): ETipoPeriodo[] {
    return [ETipoPeriodo.NONE,ETipoPeriodo.ANTERIOR,ETipoPeriodo.COMPLETO,ETipoPeriodo.POSTERIOR];
  }
}


export enum EFaixaEtaria {
  NONE = 0,
  ADULTO = 1,
  INFANTIL = 2,
  BB = 3,
}

export namespace EFaixaEtaria {
  export function toDisplay(arg: EFaixaEtaria): string {
    switch (arg) {
      case 0: return "";
      case 1: return "Adulto";
      case 2: return "Infantil";
      case 3: return "Bebe";
      default: return "";
    }
  }

  export function enums(): EFaixaEtaria[] {
    return [EFaixaEtaria.NONE,EFaixaEtaria.ADULTO,EFaixaEtaria.INFANTIL,EFaixaEtaria.BB];
  }
}


export class DataListaClienteMacleAPP extends BaseData {
  readonly jclass: string = "com.sollus.vo.DataListaClienteMacleAPP";
  listCli: ArrayList<DataClienteMacleAPP> = new ArrayList<DataClienteMacleAPP>(DataClienteMacleAPP);
}


export class JsonObject {
  readonly jclass: string = "com.sollus.json.JsonObject";
}


export enum EStatusPedidoSite {
  NONE = 0,
  PRECONFPAGTO = 7,
  CONFERENCIAPAGTO = 1,
  EMANALISE = 10,
  APROVADO = 6,
  REPROVADO = 8,
  PRONTO_RETIRA = 13,
  EXPEDICAO = 2,
  EMBARQUE = 3,
  ENTREGUE = 4,
  CANCELADO = 5,
  DEVOLUCAO = 9,
  CONTESTADO = 11,
  NAOFINALIZADO = 12,
}

export namespace EStatusPedidoSite {
  export function toDisplay(arg: EStatusPedidoSite): string {
    switch (arg) {
      case 0: return "";
      case 7: return "Pre confirmacao";
      case 1: return "Conf. pagto";
      case 10: return "Em analise";
      case 6: return "Aprovado";
      case 8: return "Reprovado";
      case 13: return "Pronto Retirar";
      case 2: return "Expedicao";
      case 3: return "Embarque";
      case 4: return "Entregue";
      case 5: return "Cancelado";
      case 9: return "Devolucao";
      case 11: return "Contestado";
      case 12: return "Pedido nao Finalizado";
      default: return "";
    }
  }

  export function enums(): EStatusPedidoSite[] {
    return [EStatusPedidoSite.NONE,EStatusPedidoSite.PRECONFPAGTO,EStatusPedidoSite.CONFERENCIAPAGTO,EStatusPedidoSite.EMANALISE,EStatusPedidoSite.APROVADO,EStatusPedidoSite.REPROVADO,EStatusPedidoSite.PRONTO_RETIRA,EStatusPedidoSite.EXPEDICAO,EStatusPedidoSite.EMBARQUE,EStatusPedidoSite.ENTREGUE,EStatusPedidoSite.CANCELADO,EStatusPedidoSite.DEVOLUCAO,EStatusPedidoSite.CONTESTADO,EStatusPedidoSite.NAOFINALIZADO];
  }
}


